<template>
    <div>
        <SoliForm
            :title="'Manage Enrollment'"
            @submit="submitUpdateStudents"
            @reset="$emit('reset')"
            :saveChanges="enrollmentLoading"
            @hook:mounted="loadStudentLists"
            ref="updateStudents"
            text="Save"
            ><template #body>
                <SoliStudents
                    v-if="
                        (event.group_event.recurring &&
                            event.type == 'Event') ||
                        event.event_register_id
                    "
                    ref="enrolled"
                    v-model="updateStudents"
                    multiple
                    chips
                    :dense="false"
                    label="Enrolled Students"
                    deletableChips
                    closeOnClick
                    smallChips
                    :autocomplete="true"
                    :enrolled="enrolledStudents"
                    :filter="guestStudents"
                    :lessonType="event.group_event?.access ?? null"
                    onDemand
                    :groupEventId="event.group_event?.id"
                    @loaded="enrolledLoaded = true"
                    @hook:mounted="enrolledLoaded = false"
                    @select="handleSelectEnrolled($event)"
                ></SoliStudents>
                <SoliStudents
                    v-if="!event.event_register_id"
                    v-model="updateGuests"
                    ref="guests"
                    multiple
                    label="Guests"
                    chips
                    deletableChips
                    closeOnClick
                    smallChips
                    :dense="false"
                    :autocomplete="true"
                    :guests="guestStudents"
                    :filter="enrolledStudents"
                    guestPasses
                    :lessonType="event.group_event?.access ?? null"
                    onDemand
                    :groupEventId="event.group_event?.id"
                    @loaded="guestsLoaded = true"
                    @hook:mounted="guestsLoaded = false"
                    @select="handleSelectGuest($event)"
                    @remove="handleRemoveGuest($event)"
                ></SoliStudents> </template
        ></SoliForm>
        <SoliChoice
            v-if="showCapacityWarning"
            @reset="showCapacityWarning = null"
            title="Hold up"
            :subtitle="`This class has reached capacity on the following dates. Student(s) have not been enrolled${
                moment(showCapacityWarning[0]).isSame(
                    moment(event.starts_at),
                    'day'
                )
                    ? ' or added as guests.'
                    : ', but any guests and first visit students have been added successfully.'
            }`"
            button1="Okay"
            @option1="
                [
                    ($refs.updateStudents.dialog = false),
                    $emit('success'),
                    ($page.props.successMessage =
                        'Error adding students to class'),
                ]
            "
            permanent
            ><template
                ><v-list dense>
                    <v-list-item
                        v-for="conflict in showCapacityWarning"
                        :key="conflict"
                        ><small class="soli-grey">{{
                            `${globalMomentDate(conflict)}`
                        }}</small></v-list-item
                    >
                </v-list>
            </template>
        </SoliChoice>
        <SoliChoice
            v-if="showNoAvailableOptionAlert"
            @reset="showNoAvailableOptionAlert = false"
            title="Uh oh"
            :subtitle="`${selectedStudent?.name} does not have an available purchase option for this class.`"
            button1="Visit Store"
            button2="Nevermind"
            @option1="visitStore()"
            @option2="cancelAddToClass()"
            permanent
        >
        </SoliChoice>
        <SoliChoice
            v-if="showFirstVisitAlert"
            @reset="showFirstVisitAlert = false"
            title="First Visit?"
            :subtitle="`Is this ${selectedStudent?.name}'s first visit to ${this.event.group_event.title}? Adding them to this class will send an automated welcome email.`"
            button1="Yep!"
            button2="No"
            @option1="confirmFirstVisit()"
            @option2="cancelFirstVisit()"
            :disabled1="!billingUser"
            permanent
            ><template
                ><v-select
                    solo
                    outlined
                    class="soli-grey pa-2"
                    dense
                    hide-details
                    return-object
                    flat
                    item-text="name"
                    item-value="id"
                    v-model="billingUser"
                    label="Billing User"
                    :items="relationshipsAndMe"
                ></v-select
            ></template>
        </SoliChoice>
        <!--<SoliChoice
            v-if="labWarningAlert"
            @reset="labWarningAlert = false"
            title="Hold up"
            :subtitle="`This is not the recommended process for ${event.group_event?.title}. Are you sure?`"
            button1="Yep!"
            button2="No"
            @option1="confirmFirstVisit(true)"
            @option2="cancelFirstVisit()"
            permanent
        >
        </SoliChoice>-->
        <!--<SoliChoice
            v-if="labEnrollmentAlert"
            @reset="labEnrollmentAlert = false"
            title="Enroll Student"
            :subtitle="`Is this ${selectedStudent.name}'s first visit to ${this.event.group_event.title}? Adding them to this class will send an automated welcome email and bill the following to their account.`"
            button1="Confirm"
            button2="Nevermind"
            :disabled1="!billingUser"
            @option1="confirmEnrollStudent()"
            @option2="cancelFirstVisit(false)"
            permanent
            ><v-list>
                <v-list-item dense v-if="selectedStudent.relationships.length"
                    ><v-select
                        item-text="name"
                        item-value="id"
                        label="Billing Account"
                        return-object
                        prepend-inner-icon="people"
                        outlined
                        dense
                        :items="relationshipsAndMe"
                        v-model="billingUser"
                    ></v-select
                ></v-list-item>
                <v-list-item dense class="text-body-2 soli-grey">{{
                    `Enrollment Fee: ${formatUnitAmount(
                        pricing.enrollmentFee.unit_amount
                    )}`
                }}</v-list-item>
                <v-list-item dense class="text-body-2 soli-grey">{{
                    `Prorated Membership:  ${formatUnitAmount(
                        pricing.membershipProration.proration
                    )} (${globalMomentDateDots(
                        new Date(pricing.membershipProration.starts_at)
                    )} to ${globalMomentDateDots(
                        new Date(pricing.membershipProration.anchor)
                    )}`
                }}</v-list-item>
                <v-list-item dense class="text-body-2 soli-grey">{{
                    `Then ${formatUnitAmount(
                        pricing.membershipPrice.unit_amount
                    )}/month starting ${globalMomentDateDots(
                        new Date(pricing.membershipProration.cycle)
                    )}`
                }}</v-list-item>
            </v-list>
        </SoliChoice>-->
    </div>
</template>

<script>
import globalMoment from "../Mixins/GlobalMoment.js";

export default {
    props: ["event"],
    mixins: [globalMoment],
    data() {
        return {
            enrolledLoaded: true,
            guestsLoaded: true,
            updateStudents: [],
            updateGuests: [],
            selectedStudent: null,
            showNoAvailableOptionAlert: false,
            labEnrollmentAlert: false,
            firstVisitStudents: [],
            enrollStudents: [],
            showFirstVisitAlert: false,
            labWarningAlert: false,
            pricing: null,
            showCapacityWarning: false,
            billingUser: null,
        };
    },
    computed: {
        relationshipsAndMe() {
            if (!this.selectedStudent) return [];
            return this.selectedStudent.email
                ? [this.selectedStudent, ...this.selectedStudent.relationships]
                : this.selectedStudent.relationships;
        },
        enrolledStudents() {
            return this.event.students
                .filter((e) => !e.attendance.is_guest)
                .map((e) => e.id);
        },
        guestStudents() {
            return this.event.students
                .filter((e) => e.attendance.is_guest)
                .map((e) => e.id);
        },
        /*getUpdateStudents() {
            return [
                ...new Set(
                    this.updateStudents
                        .concat(
                            this.event.students.filter(
                                (e) => !e.attendance.is_guest
                            )
                        )
                        .map((e) => e.id)
                ),
            ];
        },
        getUpdateGuests() {
            return [
                ...new Set(
                    this.updateGuests
                        .concat(
                            this.event.students.filter(
                                (e) => e.attendance.is_guest
                            )
                        )
                        .map((e) => e.id)
                ),
            ];
        },*/
        enrollmentLoading() {
            return this.enrolledLoaded && this.guestsLoaded;
        },
    },
    methods: {
        visitStore() {
            let billingUser = !this.selectedStudent.email
                ? this.selectedStudent.relationships.find((e) => e.email)
                : this.selectedStudent;

            this.$inertia.visit(
                route("store", {
                    tab: "frequent",
                    user: billingUser?.id,
                })
            );
        },
        getEventPricing() {
            return;
            axios
                .get(
                    `/api/group-event/pricing/${this.event.group_event.id}`,

                    {
                        params: {
                            lessonId: this.event?.id,
                        },
                    }
                )
                .then((resp) => {
                    this.pricing = resp.data;
                });
        },
        handleSelectEnrolled(student) {
            this.selectedStudent = student;

            if (!this.selectedStudent) return;
            if (this.selectedStudent.validated) return;

            /*if (this.event.group_event?.can_exchange_passes) {
                return (this.labEnrollmentAlert = true);
            }*/

            if (this.validatePurchaseOption(student)) return;

            this.showNoAvailableOptionAlert = true;
        },
        handleSelectGuest(student) {
            this.selectedStudent = student;

            if (!this.selectedStudent) return;
            if (this.selectedStudent.validated) return;

            if (this.validatePurchaseOption(student)) return;

            this.showFirstVisitAlert = true;
        },
        handleRemoveGuest(student) {
            if (!student) return;
            this.firstVisitStudents = this.firstVisitStudents.filter(
                (e) => e.userId !== student.id
            );
        },
        validatePurchaseOption(user) {
            if (!user) return;
            return user.purchase_options?.find((e) =>
                e.access.includes(this.event.group_event.access)
            );
        },
        cancelAddToClass() {
            this.updateStudents = this.updateStudents.filter(
                (e) => e.id !== this.selectedStudent.id
            );
            this.updateGuests = this.updateGuests.filter(
                (e) => e.id !== this.selectedStudent.id
            );

            this.closeModal(() => (this.showNoAvailableOptionAlert = false));
        },
        cancelFirstVisit(showAlert = true) {
            if (showAlert) this.showNoAvailableOptionAlert = true;
            if (!showAlert) this.cancelAddToClass();
            this.closeModal(() => (this.showFirstVisitAlert = false));
        },
        /*confirmEnrollStudent() {
            this.enrollStudents.push({
                userId: this.selectedStudent.id,
                billingUserId: this.billingUser.id,
            });
        },*/
        confirmFirstVisit(labConfirm = false) {
            /*if (this.event.group_event?.can_exchange_passes && !labConfirm) {
                return (this.labWarningAlert = true);
            }*/
            this.firstVisitStudents.push({
                userId: this.selectedStudent.id,
                billingUserId: this.billingUser.id,
                //billingUserId: this.selectedStudent.id,
            });
        },
        submitUpdateStudents() {
            this.$inertia.put(
                route("lesson.updateStudents", this.event?.id),
                {
                    students: this.updateStudents.map((e) => e.id),
                    guests: this.updateGuests.map((e) => e.id),
                    firstVisitStudents: this.firstVisitStudents,
                    //enrollStudents: this.enrollStudents,
                },
                {
                    preserveState: true,
                    preserveScroll: true,
                    onSuccess: () => {
                        this.$refs.updateStudents.dialog = false;
                        this.$emit("success");
                    },
                    onError: (errors) => {
                        if (errors.conflicts) {
                            this.showCapacityWarning = errors.conflicts;
                            return;
                        }
                        console.log(errors);
                    },
                }
            );
        },
        loadStudentLists() {
            this.updateStudents = this.event.students.filter(
                (e) => !e.attendance.is_guest
            );
            this.updateGuests = this.event.students
                .filter((e) => e.attendance.is_guest)
                .map((e) => {
                    e.disabled = !!e.attendance.status;
                    return e;
                });
        },
    },
    watch: {
        selectedStudent(value) {
            this.billingUser = !value.relationships.length
                ? value
                : this.relationshipsAndMe.length == 1
                ? value.relationships[0]
                : null;
        },
    },
    mounted() {
        //this.getEventPricing();
    },
};
</script>
